import React from 'react';
import ProjectCard from './ProjectCard';
import { projects } from '../data/projects';
import './project.css';

const Projects = () => {
  return (
    <section id="projects" style={{ padding: '4rem 1rem' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <h2 style={{ fontSize: '1.6rem', marginBottom: '1rem', textAlign: 'center' }}>Selected projects</h2>
        <p style={{ textAlign: 'center', color: '#97a3b3', maxWidth: '64ch', margin: '0 auto 2rem' }}>A few examples of work — click View to open each project (placeholder links).</p>

        <div className="projectsGrid">
          {projects.map((p) => (
            <ProjectCard key={p.id} project={p} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
